import { useEffect } from 'react';

class BodyScrollLocker {
  #isLocked = false;
  #onChangeCb: () => unknown = () => {};
  #onDestroyCb: () => unknown = () => {};

  get isLocked() {
    return this.#isLocked;
  }

  destroy() {
    this.#onDestroyCb();
  }

  lock() {
    this.#isLocked = true;
    this.#onChangeCb();
  }

  unlock() {
    this.#isLocked = false;
    this.#onChangeCb();
  }

  onChange(cb: () => unknown) {
    this.#onChangeCb = cb;

    return () => (this.#onChangeCb = () => {});
  }

  onDestroy(cb: () => unknown) {
    this.#onDestroyCb = cb;

    return () => (this.#onDestroyCb = () => {});
  }
}

const BodyScrollLock = new (class BodyScrollLockClass {
  lockers: BodyScrollLocker[] = [];
  #evaluate() {
    const willLock =
      this.lockers.filter((current) => current.isLocked).length > 0;

    document.body.style.maxHeight = '100vh';

    if (willLock && document.body.scrollHeight > document.body.clientHeight)
      document.body.style.paddingRight = '10px';

    document.body.style.overflow = willLock ? 'hidden' : 'auto';

    if (!(willLock && document.body.scrollHeight > document.body.clientHeight))
      document.body.style.paddingRight = '0px';
  }

  getLocker() {
    const locker = new BodyScrollLocker();
    locker.onChange(() => this.#evaluate());
    locker.onDestroy(() => {
      this.lockers = this.lockers.filter((current) => current !== locker);
      this.#evaluate();
    });
    this.lockers.push(locker);

    return locker;
  }
})();

export function useBodyScrollLock(isLocked: boolean) {
  useEffect(() => {
    const locker = BodyScrollLock.getLocker();
    if (isLocked) locker.lock();
    else locker.unlock();

    return () => {
      locker.destroy();
    };
  }, [isLocked]);
}
